/* Modismo, Co. store script. Store-only behavior; the shared site script is modismo.js.
   Small on purpose. Every page works without it:
     - a product with options falls back to a plain menu of variants,
     - "also held." simply stays empty,
     - forms post the ordinary way.
   No third-party code, no tracking, nothing loaded from another site. */
(function () {
  'use strict';

  /* ---------- 1. Product page: keep the chosen variant in step with the pickers ---------- */

  var FIELDS = ['tuna', 'cobalt', 'agave', 'marigold', 'temple', 'black', 'bone', 'white', 'panel', 'cool'];

  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataNode = root.querySelector('[data-product-json]');
    var idInput = root.querySelector('[data-variant-id]');
    if (!dataNode || !idInput) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      return; // Leave the form as the server sent it.
    }

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
    var button = root.querySelector('[data-add-button]');
    var buttonLabel = root.querySelector('[data-add-label]');
    var buttonIcon = root.querySelector('[data-add-icon]');
    var price = root.querySelector('[data-price]');
    var compare = root.querySelector('[data-compare]');
    var compareValue = root.querySelector('[data-compare-value]');
    var status = root.querySelector('[data-variant-status]');
    var header = document.querySelector('[data-site-header]');

    // The hidden variant field is sent switched off, so that without this script the
    // plain menu is used instead. Now that the script is running, switch it on.
    idInput.disabled = false;
    if (!groups.length) return;

    function selectedValues() {
      return groups.map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function sameOptions(variant, values) {
      return variant.options.every(function (option, index) {
        return option === values[index];
      });
    }

    function findVariant(values) {
      for (var i = 0; i < data.variants.length; i++) {
        if (sameOptions(data.variants[i], values)) return data.variants[i];
      }
      return null;
    }

    // Strike through the values that are out of stock for the current combination.
    function markAvailability(values) {
      groups.forEach(function (group, groupIndex) {
        group.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var trial = values.slice();
          trial[groupIndex] = input.value;
          var variant = findVariant(trial);
          input.disabled = !(variant && variant.available);
        });
      });
    }

    function setHeader(field) {
      if (!header) return;
      var next = FIELDS.indexOf(field) > -1 ? 'bg-' + field : 'site-header--plain';
      FIELDS.forEach(function (name) {
        header.classList.remove('bg-' + name);
      });
      header.classList.remove('site-header--plain');
      header.classList.add(next);
    }

    // Show the picture that belongs to the chosen variant in the large frame.
    function showMedia(mediaId) {
      if (!mediaId) return;
      var main = root.querySelector('[data-gallery-main]');
      if (!main || main.getAttribute('data-media-id') === String(mediaId)) return;
      var thumb = root.querySelector('.pdp__thumb[data-media-id="' + mediaId + '"]');
      if (!thumb) return;
      var mainImage = main.querySelector('img');
      var thumbImage = thumb.querySelector('img');
      if (!mainImage || !thumbImage) return;
      ['srcset', 'src', 'alt', 'width', 'height'].forEach(function (name) {
        var held = mainImage.getAttribute(name);
        var incoming = thumbImage.getAttribute(name);
        if (incoming === null) mainImage.removeAttribute(name); else mainImage.setAttribute(name, incoming);
        if (held === null) thumbImage.removeAttribute(name); else thumbImage.setAttribute(name, held);
      });
      thumb.setAttribute('data-media-id', main.getAttribute('data-media-id'));
      main.setAttribute('data-media-id', String(mediaId));
    }

    function update(announce) {
      var values = selectedValues();
      var variant = findVariant(values);
      var available = Boolean(variant && variant.available);

      markAvailability(values);

      groups.forEach(function (group, index) {
        var current = group.querySelector('[data-option-current]');
        if (current && values[index] !== null) current.textContent = values[index];
      });

      if (variant) {
        idInput.value = variant.id;
        if (price) price.textContent = variant.price;
        if (compare && compareValue) {
          compare.hidden = !variant.compare;
          compareValue.textContent = variant.compare || '';
        }
        setHeader(variant.field);
        showMedia(variant.media);
        // Keep the address in step, so a shared or reloaded link opens the same variant.
        if (announce && window.history && window.history.replaceState && window.URL) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      var label = available ? data.addToBag : (variant ? data.soldOut : data.unavailable);
      if (button) button.disabled = !available;
      if (buttonLabel) buttonLabel.textContent = label;
      if (buttonIcon) buttonIcon.hidden = !available;

      // Tell screen reader users what changed, in words.
      if (announce && status) {
        var parts = values.filter(function (value) { return value !== null; });
        parts.push(available && variant ? variant.price : label);
        status.textContent = parts.join(', ');
      }
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function () {
        update(true);
      });
    });

    update(false);
  });

  /* ---------- 2. Product page: fetch "also held." ---------- */

  document.querySelectorAll('[data-recommendations]').forEach(function (holder) {
    var url = holder.getAttribute('data-url');
    if (!url || holder.children.length || !window.fetch || !window.DOMParser) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (!html) return;
        var fetched = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
        if (fetched && fetched.children.length) holder.innerHTML = fetched.innerHTML;
      })
      .catch(function () {
        /* No recommendations. The section stays empty. */
      });
  });

  /* ---------- 3. After a form is sent: move to the message so it is seen and read out ---------- */

  var message = document.querySelector('[data-form-status]');
  if (message) message.focus();
})();
